import errorMsg from '../views/component/errorMsg';
import login from '../views/login/login';
import kygMsg from '../js/kygMsg';
import spinRoute from './spinRoute';

//返回函数延迟调用，以加载多语言
export default () => [
    {
        path: '/errorMsg',
        component: errorMsg,
        meta: { title: '' }
    },
    {
        path: '/login',
        component: login,
        meta: { title: kygMsg(111140, '登录') }
    },
    {
        name: 'fullScreenChart',
        path: '/fullScreenChart',
        meta: { title: kygMsg(321734, '横屏图表') },
        component: () => spinRoute.require(import('../views/component/chart/fullScreenChart.vue')),
    }
]
